import {all, takeLatest, call, put, select} from 'redux-saga/effects'
import {isEmpty} from 'lodash'
import {errors} from 'config/strings'
import types from '../actions/types'
import * as contactActions from '../actions/contacts'

export default (api) => {

  function* checkFieldOptions() {
    try {
      const companyFields = yield select(state => state.data.companyFields)
      const contactFields = yield select(state => state.data.contactFields)
      const individualFields = yield select(state => state.data.individualFields)

      // If all the data fields and selected fields are in place load the contact and company field options
      if (isEmpty(companyFields) && isEmpty(contactFields) && isEmpty(individualFields)) {
        const fields = companyFields.concat(individualFields).concat(contactFields)

        const optionFields = []
        for (const field in fields) {
          if (fields[field].dataType === 'List' || fields[field].dataType === 'Multi List') {
            const fieldSet = new Set(optionFields)
            if (!fieldSet.has(fields[field].key)) optionFields.push(fields[field].key)
          }
        }

        yield put(getFieldOptions(optionFields))
      }
    } catch (e) {
      yield put(contactActions.getFieldOptionsFailure(errors.CHECK_FIELD_OPTIONS, 0))
      console.error(e)
    }
  }

  function* getFieldOptions({optionFields}) {
    try {
      const response = yield call(api.fieldsOptions.get, {key: optionFields}, {})
      yield api.handleResponse(
        response,
        function* onOk(key, data) {
          const fieldOptions = data.result
          yield put(contactActions.getFieldOptionsSuccess(fieldOptions))
        },
        function* onFail() {
          yield put(contactActions.getFieldOptionsFailure(response.data.message, response.data.errorCode))
        }
      )
    } catch (e) {
      yield put(contactActions.getFieldOptionsFailure(errors.FIELD_OPTIONS, 0))
      console.error(e)
    }
  }

  function* watcher() {
    yield all([
      takeLatest(types.CONTACTS_SET_COMPANY_FIELDS, checkFieldOptions),
      takeLatest(types.CONTACTS_SET_INDIVIDUAL_FIELDS, checkFieldOptions),
      takeLatest(types.CONTACTS_SET_CONTACT_FIELDS, checkFieldOptions),
      takeLatest(types.CONTACTS_GET_FIELD_OPTIONS_ATTEMPT, getFieldOptions),
    ])
  }

  return {
    watcher,
  }
}
